function OfflineSegmentsFormController(stateService, CommonService, toasterService, $uibModal) {
  const ctrl = this;
  const preLoadAudio = CommonService.preLoadAudio;
  const checkName = CommonService.checkName;

  ctrl.$onInit = () => {
    if (!ctrl.selection) {
      ctrl.clearCurrentSegment();
      ctrl.newSegment = true;
      ctrl.viewMode = false;
    } else {
      ctrl.segmentAudio = angular.copy(ctrl.selection);
      ctrl.segmentText = this.segmentsText.find(s => s.number === ctrl.selection.number);
      ctrl.setTextValues();
      ctrl.newSegment = false;
      ctrl.viewMode = true;
      ctrl.filteredFiles = preLoadAudio(ctrl.segmentAudio);
      ctrl.fileModel = {};
      ctrl.fileModel.file = '';
    }
    // Actor parameter is currently unused, but needs to be -1
    ctrl.segmentAudio['actor'] = -1;
    ctrl.segmentText['actor'] = -1;
  };

  ctrl.$onChanges = changes => {
    if (changes.selection && ctrl.viewMode) {
      ctrl.segmentAudio = angular.copy(ctrl.selection);
      ctrl.filteredFiles = preLoadAudio(ctrl.segmentAudio);
    }
  };

  ctrl.clearCurrentSegment = () => {
    ctrl.segmentAudio = {
      id: -1,
      name: null,
      description: null,
      stream_type: 'AUDIO',
      offline: true,
      simulator_script: false
    };
    ctrl.segmentText = {
      id: -1,
      name: null,
      description: null,
      text: null,
      stream_type: 'TEXT',
      offline: true,
      simulator_script: false
    };
  }

  ctrl.onUpdateName = ($event) => {
    ctrl.duplicateName = checkName(ctrl.segments, ctrl.segmentAudio);
    if (!ctrl.duplicateName) {
      ctrl.segmentText.name = $event.target.value;
    }
  };
  
  ctrl.onUpdateDescription = ($event) => {
    ctrl.segmentText.description = $event.target.value;
  }

  ctrl.setTextValues = () => {
    if (ctrl.segmentAudio && ctrl.segmentAudio.number) {
      ctrl.refreshTextSegment(ctrl.segmentAudio.number);
    }
  }

  ctrl.refreshTextSegment = (number) => {
    ctrl.segmentText = ctrl.segmentsText.find(seg => seg.number === number);
  }

  ctrl.checkValidity = () => {
    return ctrl.segmentAudio.name.length === 0 || ctrl.duplicateName;
  };

  ctrl.toggleEditMode = value => {
    if (value) {
      ctrl.viewMode = false;
    } else {
      ctrl.segmentAudio = angular.copy(ctrl.selection);
      ctrl.setTextValues();
      ctrl.viewMode = true;
    }
  };

  ctrl.fileSelected = (event, files) => {
    if (!files || files.length === 0) return;
    let file = files[0];
    ctrl.fileModel.file = file;
    ctrl.openUploadModal();
  };

  ctrl.openUploadModal = function () {
    let modalInstance = $uibModal.open({
      component: 'offlineFileUploadModal',
      resolve: {
        file: function () {
          return ctrl.fileModel.file;
        },
      },
    });

    modalInstance.result
      // User pressed 'Accept'
      .then(() => {
        stateService.uploadOfflineAudio(ctrl.segmentAudio.id, ctrl.segmentAudio.number, ctrl.fileModel.file).then((response) => {
          ctrl.onFileUpload({
            $event: {
              current: ctrl.segmentAudio,
            },
          });
          if (response.statusCode !== 422 && response.statusCode !== 500) {
            toasterService.success('toaster.pis-event', 'toaster.pis-segment-fileupload-successful');
          } else {
            toasterService.error('toaster.pis-segment-fileupload-failure', 'toaster.pis-segment-fileupload-failure');
          }
        });
      });
  };

  ctrl.clearForm = () => {
    if (ctrl.segmentForm) {
      ctrl.segmentForm.$setPristine(true);
      ctrl.segmentForm.$setUntouched(true);
    }
    ctrl.viewMode = false;
    ctrl.duplicateName = false;
    ctrl.clearCurrentSegment();
  };

  ctrl.onSubmit = () => {
    if (ctrl.newSegment) {
      // Ensure that TEXT segment has identical values with the AUDIO segment
      ctrl.setTextValues();
      const allCreated = Promise.all([
        stateService.createSegment(ctrl.segmentAudio),
        stateService.createSegment(ctrl.segmentText)  
      ]);

      allCreated
        .then(() => {
          ctrl.onFormSubmit({
            $event: {
              mode: false,
            },
          });
          if (response.statusCode === 200) {
            toasterService.success('toaster.pis-event', 'toaster.pis-new-segment-successful');
          } else {
            toasterService.error('toaster.pis-event', 'toaster.pis-new-segment-failure');
          }
        })
        .catch((err) =>{
          console.error(err);
          toasterService.error('toaster.pis-event', 'toaster.pis-new-segment-failure');
        })
    } else {
      // EDIT
      const allEdited = Promise.all([
        stateService.editSegment(ctrl.segmentAudio.id, ctrl.segmentAudio),
        stateService.editSegment(ctrl.segmentText.id, ctrl.segmentText)  
      ]);

      allEdited
        .then(() => {
          ctrl.onFormSubmit({
            $event: {
              mode: false,
            },
          });
          toasterService.success('toaster.pis-event', 'toaster.pis-edit-segment-successful');
        })
        .catch((err) =>{
          console.error(err);
          toasterService.error('toaster.pis-event', 'toaster.pis-edit-segment-failure');
        })
    }
  };
}

angular
  .module('offline.module')
  .controller('OfflineSegmentsFormController', OfflineSegmentsFormController);
